import { HttpClient } from '@angular/common/http';

import { TranslateLoader } from '@ngx-translate/core';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export class MultiTranslateHttpClientLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private resources: { prefix: string; suffix: string }[],
  ) {}

  public getTranslation(lang: string): Observable<any> {
    const requests = this.resources.map((resource) =>
      this.http.get(`${resource.prefix}${lang.toLowerCase()}${resource.suffix}`),
    );
    return forkJoin(requests).pipe(
      map((response) => Object.assign({}, ...response)),
    );
  }
}

export function HttpClientLoaderTranslation(http: HttpClient) {
  return new MultiTranslateHttpClientLoader(http, [
    {
      prefix: 'assets/i18n/commons/',
      suffix: '.json?v=' + new Date().getTime(),
    },
    { prefix: 'assets/i18n/', suffix: '.json?v=' + new Date().getTime() },
  ]);
}
